import { useNavigate, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Megaphone } from 'lucide-react';
import api from '@/lib/api';
import { useAuthStore } from '@/stores/auth-store';

export default function NoticeIndicator() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  const { data: count = 0 } = useQuery({
    queryKey: ['notices', 'unread-count'],
    queryFn: async () => {
      const res = await api.get('/notices/unread-count');
      return res.data.data?.count ?? 0;
    },
    enabled: isAuthenticated,
    refetchInterval: 30_000,
  });

  const isActive = location.pathname.startsWith('/notices');

  return (
    <button
      onClick={() => navigate('/notices')}
      className={`relative p-2 rounded-md transition-colors ${
        isActive
          ? 'text-orange-600 bg-orange-50'
          : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100'
      }`}
      title="공지사항"
    >
      <Megaphone size={20} />
      {count > 0 && (
        <span className="absolute -top-0.5 -right-0.5 flex items-center justify-center min-w-5 h-5 px-1 text-[11px] font-bold text-white bg-orange-500 rounded-full">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
}
